module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "element element-non-bodymatter element-container-single element-type-none element-with-heading",
    attrs: {
      "id": "uncategorized"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "uncategorized-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Book Description")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "uncategorized-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("An epic of the first manned mission to Mars, created by political mastermind Allen Drury, Pulitzer Prize-winning author of "), _c('i', [_vm._v("Advise and Consent")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("After showing us the deep inner workings of Washington politics, Allen Drury turns his keen, dissecting eye on a complex space mission—the drama, the suspense, and the politics of America’s race to put the first human on the planet Mars.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Mission Commander Conrad Trasker faces countless problems and challenges—a maverick veteran astronaut who demands a place on the crew; a moody, crusading doctor, whose refusal to cooperate jeopardizes the lives of his crewmates; a union leader who tries to sabotage the flight for sinister political purposes; and a constant barrage of criticism from ambitious politicians and the nation’s media.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Against this background, Trasker and Planetary Fleet One plunge toward their rendezvous deep in interplanetary space … and a crisis that threatens not only the lives of the crew, but the entire future of American leadership in space.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0feff2f1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bookdescription.vue
// module id = 60
// module chunks = 0